import s from"./addClasses.js";import e from"./removeClasses.js";const a={addClasses:s,removeClasses:e};export{a as default};
//# sourceMappingURL=index.js.map
